import ApiService from '@/services/core/api.service'

const LeadService = {
  async get (query) {
    return ApiService.get(`user/my-leads?${query}`)
  }
}

export default LeadService
